import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const constApi = {
  config_room_list: baseAPI + baseUrl + 'room/config/list',
  room_status_change: baseAPI + baseUrl + 'room/config/room/valid',
  config_room_create: baseAPI + baseUrl + 'room/config/batch/create',
  config_room_update: baseAPI + baseUrl + 'room/config/update',
}


// 改变房间状态
export const changeRoomStatusReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.room_status_change,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

// 创建
export const getRoomConfigListReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.config_room_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: {
      ...data
    }
  })
  return res
}

// 更新
export const addRoomConfigReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.config_room_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 导出
export const updateRoomConfigReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.config_room_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: {
      ...data,
      operator: store.getters.username,
    }
  })
  return res
}
